(function(){
  var CHALD={a:1,b:2,c:3,d:4,e:5,f:8,g:3,h:5,i:1,j:1,k:2,l:3,m:4,n:5,o:7,p:8,q:1,r:2,s:3,t:4,u:6,v:6,w:6,x:5,y:1,z:7};
  var CVOWELS='aeiouy';

  function reduce(n){
    while(n>9&&n!==11&&n!==22&&n!==33){
      var s=0;String(n).split('').forEach(function(d){s+=parseInt(d);});n=s;
    }
    return n;
  }

  var D={
    1:{t:'The Leader',d:'You are a natural-born leader, independent and pioneering. Your purpose is to forge new paths for others to follow.'},
    2:{t:'The Peacemaker',d:'You are a natural diplomat, sensitive and cooperative. Your purpose is to bring harmony and balance into all relationships.'},
    3:{t:'The Communicator',d:'You are creative, expressive, and social. Your purpose is to inspire others through art, words, and joyful self-expression.'},
    4:{t:'The Builder',d:'You are disciplined, reliable, and hardworking. Your purpose is to create solid foundations and lasting structures.'},
    5:{t:'The Freedom Seeker',d:'You are adventurous, dynamic, and adaptable. Your purpose is to embrace change, freedom, and diverse experiences.'},
    6:{t:'The Nurturer',d:'You are loving, responsible, and caring. Your purpose is to serve and nurture family, community, and those in need.'},
    7:{t:'The Seeker',d:'You are analytical, intuitive, and spiritual. Your purpose is to seek truth and deeper understanding of life mysteries.'},
    8:{t:'The Achiever',d:'You are ambitious and business-minded. Your purpose is to achieve abundance through your own efforts.'},
    9:{t:'The Humanitarian',d:'You are compassionate, idealistic, and generous. Your purpose is to serve humanity and make the world a better place.'},
    11:{t:'The Intuitive (Master Number)',d:'You are a highly sensitive spiritual messenger. Your purpose is to inspire and illuminate others with your intuitive gifts.'},
    22:{t:'The Master Builder',d:'You are a visionary with practical power to manifest great dreams. Your purpose is to build something of lasting value for the world.'},
    33:{t:'The Master Teacher',d:'You are a compassionate healer and guide. Your purpose is to uplift humanity through unconditional love and selfless service.'}
  };

  function show(pfx,num){
    var data=D[num]||{t:'',d:''};
    document.getElementById(pfx+'-num').textContent=num;
    document.getElementById(pfx+'-title').textContent=data.t;
    document.getElementById(pfx+'-desc').textContent=data.d;
    document.getElementById(pfx+'-result').classList.add('visible');
  }

  function onlyLetters(str){
    return str.toLowerCase().replace(/[^a-z]/g,'');
  }

  function init(){
    document.querySelectorAll('.gls-tab-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        document.querySelectorAll('.gls-tab-btn').forEach(function(b){b.classList.remove('active');});
        document.querySelectorAll('.gls-panel').forEach(function(p){p.classList.remove('active');});
        btn.classList.add('active');
        document.getElementById('gls-tab-'+btn.dataset.tab).classList.add('active');
      });
    });

    window.glsCalcLP=function(){
      var dob=document.getElementById('lp-dob').value;
      var err=document.getElementById('lp-err');
      var box=document.getElementById('lp-result');
      err.style.display='none';box.classList.remove('visible');
      if(!dob){err.style.display='block';return;}
      var parts=dob.split('-');
      var sum=0;
      (parts[0]+parts[1]+parts[2]).split('').forEach(function(d){sum+=parseInt(d);});
      show('lp',reduce(sum));
    };

    window.glsCalcDN=function(){
      var raw=document.getElementById('dn-name').value.trim();
      var err=document.getElementById('dn-err');
      var box=document.getElementById('dn-result');
      err.style.display='none';box.classList.remove('visible');
      if(!raw){err.style.display='block';return;}
      var letters=onlyLetters(raw);
      if(!letters){err.style.display='block';return;}
      var sum=0;
      letters.split('').forEach(function(c){sum+=CHALD[c]||0;});
      show('dn',reduce(sum));
    };

    window.glsCalcSU=function(){
      var raw=document.getElementById('su-name').value.trim();
      var err=document.getElementById('su-err');
      var box=document.getElementById('su-result');
      err.style.display='none';box.classList.remove('visible');
      if(!raw){err.style.display='block';return;}
      var letters=onlyLetters(raw);
      if(!letters){err.style.display='block';return;}
      var sum=0;
      letters.split('').forEach(function(c){
        if(CVOWELS.indexOf(c)>-1)sum+=CHALD[c]||0;
      });
      show('su',reduce(sum));
    };
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();